const styles = {
    custom_container: "w-11/12 hidden sm:block",
    heading: 'text-[27px] text-center md:text-start font-[600] font-Roboto pb-[20px]',
    section: "w-11/12 mx-auto",
    productTitle: 'text-[25px] font-[600] font-Roboto text-[#333]',
    productDiscountPrice:"font-bold text-[18px] text-[#333] font-Roboto",
    price:"font-[500] text-[16px] text-[#d55b45] pl-3 mt-[-4px] line-through",
    shop_name:"pt-3 text-[15px] text-blue-400 pb-3",
    active_indicator:"absolute bottom-[-27%] left-0 h-[3px] w-full bg-[crimson]",
    button: 'w-[150px] bg-[#142019] h-[50px] my-3 flex items-center justify-center rounded-xl cursor-pointer text-center',
    cart_button: "px-[20px] h-[38px] rounded-[20px] bg-[#154427] flex items-center justify-center cursor-pointer",
    cart_button_text:"text-[#fff] text-[16px] font-[600]",
    input:"w-full border p-1 rounded-[5px]",
    activeStatus:"w-[10px] h-[10px] rounded-full absolute top-0 right-1 bg-[#40d132]",
    noramlFlex:"flex items-center",
    logo: "w-16 h-auto cursor-pointer",
    logoMobile: "w-10 h-auto cursor-pointer",// New style for mobile view
    // New styles for mobile responsiveness
  secondaryImage: "h-[60px] sm:h-[100px] overflow-hidden mr-3 mt-3",
  tableContainer: "overflow-x-auto",
  table: "min-w-full divide-y divide-gray-200",
  tableHeader: "bg-gray-50 px-2 py-1 text-xs md:text-sm",
  tableCell: "px-2 py-1 text-xs md:text-sm font-medium text-gray-500 uppercase tracking-wider",
  tableBody: "bg-white divide-y divide-gray-200",
  };
  
  
  export default styles;
  